export default __webpack_public_path__ + "static/media/14.30cc0636.png";